import { format, subHours } from "date-fns";

import sleepImg from "./assets/sleep.png";
import travellerImg from "./assets/traveller.png";
import pillowImg from "./assets/pillow.png";

const base =
  "w-full h-full p-3 mb-3 border-2 border-neutral-300 rounded-xl border-dashed text-center";

function WidgetGuest(kind, rec) {
  let title;
  if (kind === "check_in" && rec.arrival_today) {
    title = "Check In";
  } else if (kind === "check_out" && rec.departure_today) {
    title = "Check Out";
  }

  function getCheckStatus() {
    let personImg;
    let check_time;
    if (kind === "check_in") {
      personImg = travellerImg;
      if (rec.arrival_today) {
        if (rec.check_in_today && rec.check_in_today !== "") {
          check_time = rec.check_in_today;
        }
      }
    } else {
      personImg = sleepImg;
      if (rec.departure_today) {
        if (rec.check_out_today && rec.check_out_today !== "") {
          check_time = rec.check_out_today;
        }
      }
    }

    if (check_time) {
      check_time = subHours(check_time, 5);
      check_time = format(check_time, "hh:mm aaa");
    } else {
      check_time = "_ _ : _ _";
    }

    return (
      <div key="widget-custom-check" className="flex justify-center">
        <img key="sleep" className="w-20 h-20 mx-2" src={personImg} />
        <h2 className="my-auto text-3xl mx-2 text-stone-500 font-extrabold">
          {check_time}
        </h2>
      </div>
    );
  }

  function getPersonSleeping() {
    return (
      <img
        key="icon-no-person"
        className={"my-auto mx-auto w-20 h-20"}
        src={sleepImg}
      />
    );
  }

  function getNotPerson() {
    return (
      <img
        key="icon-no-person"
        className={"my-auto mx-auto w-20 h-20"}
        src={pillowImg}
      />
    );
  }

  let resWidget;
  if (
    (kind === "check_in" && rec.arrival_today) ||
    (kind === "check_out" && rec.departure_today)
  ) {
    resWidget = getCheckStatus();
  } else {
    if (rec.occupied_today) {
      resWidget = getPersonSleeping();
    } else {
      resWidget = getNotPerson();
    }
  }

  return (
    <div key="widget-custom" className={base}>
      <h2 className="text-3xl mb-3 font-extrabold text-neutral-600">{title}</h2>
      {resWidget}
    </div>
  );
}

export default WidgetGuest;
